<div class="">
  <div class="image-input image-input-outline" id="kt_profile_avatar" [class.image-input-empty]="!fileUrl"
    [style.backgroundImage]="'url(/assets/Icons/blank.png)'">
    <div class="image-input-wrapper" [style.backgroundImage]="getFile()">

    </div>
    <label class="position-style" data-action="change" data-toggle="tooltip" title="" data-original-title="">
      <input type="file" name="profile_avatar" accept=".png, .jpg, .jpeg" (change)="fileSelected($event)" />

      <input type="hidden" name="profile_avatar_remove" formControlName="logo" />
      <div class="add-photo">
        <div>
          <svg-icon [src]="'/assets/Icons/icon-plus.svg'"></svg-icon>
        </div>
      </div>
    </label>
    <span class="" data-action="cancel" data-toggle="tooltip" title="" data-original-title="">
    </span>
    <span *ngIf="fileUrl" class="" (click)="fileDeleted()" data-action="remove" data-toggle="tooltip" title=""
      data-original-title="">
    </span>
  </div>
  <span class="form-text text-muted w-100 d-block">{{'USER_PROFILE.PERSONAL_INFORMATION.ALLOWED_FILE_TYPES' |
    translate}}</span>
</div>
